import {
  type LucideIcon,
  CreditCard,
  Gift,
  PiggyBank,
  ShoppingCart,
  Banknote,
  Coins,
} from 'lucide-react'
import i18n from '@/i18n'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { ShopModuleType } from '@/api/model/shopModuleType'

/**
 * Shop modules have fixed, non-selectable icons per type (unlike action modules
 * with an uploaded image). Kept central here so table and dialog use the same
 * mapping. Labels come from `groups.json` (`shopModuleTypes`).
 */
export const SHOP_MODULE_META: Record<ShopModuleType, { Icon: LucideIcon }> = {
  TaxFreeBenefit: { Icon: CreditCard },
  TaxFreeBenefitBonus: { Icon: Gift },
  DirectPayout: { Icon: Banknote },
  VoucherShop: { Icon: ShoppingCart },
  CompanyPension: { Icon: PiggyBank },
  FullPayout: { Icon: Coins },
}

export function shopModuleLabel(type: ShopModuleType): string {
  return i18n.t(`shopModuleTypes.${type}`, { ns: 'groups', defaultValue: type })
}

export function ShopModuleTypeIcon({ type, className }: { type: ShopModuleType; className?: string }) {
  const Icon = SHOP_MODULE_META[type]?.Icon ?? ShoppingCart
  return <Icon className={className ?? 'size-4'} />
}

export function ShopModuleIcon({ type }: { type: ShopModuleType }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex size-8 items-center justify-center rounded-md border bg-muted/40 text-foreground">
          <ShopModuleTypeIcon type={type} />
        </span>
      </TooltipTrigger>
      <TooltipContent>{shopModuleLabel(type)}</TooltipContent>
    </Tooltip>
  )
}
